import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {ButtonJoinConfigType} from 'TemplateEditor/Layout/Blocks/ButtonJoin/ButtonJoin'
import {SliderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SliderInput'
import {DefaultBlockMobileConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockMobileConfig'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function ButtonJoinMobileConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} =
    useFormicForm<ButtonJoinConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <SliderInput
          value={values.mobile.fontSize}
          name={'mobile.fontSize'}
          label={t('templateEditor.textSizeLabel')}
          setFieldValue={setFieldValue}
          max={8}
          min={0.5}
          step={0.1}
        />

        <SliderInput
          value={values.mobile.width}
          name={'mobile.width'}
          label={t('templateEditor.buttonWidthLabel')}
          setFieldValue={setFieldValue}
          max={100}
          min={1}
          step={1}
        />

        <SliderInput
          value={values.mobile.height}
          name={'mobile.height'}
          label={t('templateEditor.buttonHeightLabel')}
          setFieldValue={setFieldValue}
          max={200}
          min={1}
          step={1}
        />

        <DefaultBlockMobileConfig
          values={values}
          setFieldValue={setFieldValue}
        />
      </form>
    </>
  )
}
